import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ElectronService } from '../services/electron.service';
import { PermissionsService } from '../../features/admin/services/permissions.service';

export const permissionsSetupGuard: CanActivateFn = async () => {
  const permissionsService = inject(PermissionsService);
  const electronService = inject(ElectronService);
  const router = inject(Router);

  if (!electronService.isElectron || permissionsService.isSetupCompleted()) {
    return true;
  }

  // If wizard was in progress (user was mid-flow when app restarted),
  // always send back to the wizard so they see the completion step.
  if (permissionsService.isSetupInProgress()) {
    return router.createUrlTree(['/permissions-setup']);
  }

  // First launch: check live permission statuses — if all already granted, skip wizard entirely
  const [platform, statuses] = await Promise.all([permissionsService.getPlatform(), permissionsService.checkPermissionStatus()]);

  const micGranted = statuses.microphone === 'granted';
  const screenGranted = platform !== 'darwin' || statuses.screen === 'granted';

  if (micGranted && screenGranted) {
    permissionsService.markSetupCompleted();
    return true;
  }

  return router.createUrlTree(['/permissions-setup']);
};
